<template>
  <section class="container">
    <h1>Welcome
      <b v-if="assetName">to {{ assetName }}</b>
      <span v-if="version" class="sub-title">{{ version }}</span>
    </h1>
    <p> Welcome to the KATE Learning Environment, use the controls below to access tools available and manage your environment.
      Note that the environment is specific to the content you have opened</p>
    <div class="service-items">
      <a class="service-btn btn btn-primary" :href="`${kodUrl}&path=/vscode/?folder=/home/kate`" target="_blank">VSCode</a>
      <a v-for="route in additionalRoutes" class="service-btn btn btn-primary" :href="`${kodUrl}&path=${route.href || route.prefix}`" target="_blank">{{ route.name }}</a>
    </div>
    <hr>
    <div class="service-items">
      <button :disabled="loading" class="service-btn btn btn-danger" @click="shutDownKod">Shut Down</button>
    </div>
  </section>
</template>

<style scoped>
section.container {
  margin: 10% auto;
  text-align: center;
}

h1 {
  text-align: center;
}

.sub-title {
  padding-left: 10px;
  font-size: 1.2rem;
  display: inline-block;
}

.service-items {
  display: flex;
  justify-content: center;
  gap: 15px;
}
</style>

<script>
export default {
  props: {
    assetName: {
      type: String,
      required: true,
    },
    assetId: {
      type: Number,
      required: true,
    },
    assetType: {
      type: String,
      required: true,
    },
    version: {
      type: String,
      default: '',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      loading: false,
    };
  },

  methods: {
    shutDownKod() {
      this.loading = true;
      this.$http.delete(
        `/api/curriculum/kods/${this.assetType}/${this.assetId}`,
        { params: { version: this.version } },
      ).then(() => {
        this.$emit('closeKod');
      }).catch(err => {
        this.$logger.autowarn('Error deleting kod for user', undefined, err);
      }).then(() => {
        this.loading = false;
      });
    },
  },

  computed: {
    kodUrl() {
      let url = `/api/curriculum/kods/${this.assetType}/${this.assetId}/redirect`;
      if (this.version) {
        url = `${url}?version=${this.version}`;
      }
      if (this.assetType.includes('pak') && !this.version) {
        url = `${url}?`;
      }
      return url;
    },
    additionalRoutes() {
      const routes = this.config.routes || [];
      const finalRoutes = (this.config?.additional_containers || []).reduce((acc, curr) => acc.concat((curr.routes || [])), routes);
      return finalRoutes;
    },
  },
};
</script>
